export const META_TAG_TITLE = '후루츠패밀리 - 빈티지, 세컨핸드 패션 중고거래 앱';


export const FILTER_KEYS = {
  GENDER: "gender",
  SUBCATEGORY_IDS: "subcategoryIds",
  BRANDS: "brands",
  PRICE_MIN: "priceMin",
  PRICE_MAX: "priceMax",
  SIZE_VALUE_IDS: "sizeValueIds",
  IS_SELLING: "isSelling",
  CONDITION: "condition",
  SORT: "sort",
};

// 검색 사이즈 필터에 노출되는 size_type 그룹 정의 (서버 size_type_id 기준).
export const SEARCH_SIZE_TYPE_GROUPS = [
  { id: 7, label: "상의 · 아우터" },
  { id: 3, label: "하의" },
  { id: 1, label: "신발" },
  { id: 8, label: "블레이저" },
];
